import { Footer } from "@components/Footer";
import { UploaderFooter } from "@components/Footer/UploaderFooter";
import { Loading } from "@components/Loading";
import { Pictures } from "@components/Pictures";
import { TopNav } from "@components/TopNav";
import { useEvent, useEventId } from "@helpers/useEvent";
import { useSimpleCollection } from "@helpers/useSimpleCollection";
import { useTranslation } from "@helpers/useTranslation";
import { FC } from "react";

type Props = {
  isAdmin: boolean;
  isUploader?: boolean;
};

export const GuestGallery: FC<Props> = ({ isAdmin, isUploader }) => {
  const eventId = useEventId();
  const { t } = useTranslation("guestgallery");
  const [event, eventLoading] = useEvent();
  const [teams, tLoading] = useSimpleCollection<Team>(`events/${eventId}/teams`);
  const [challenges, cLoading] = useSimpleCollection<Challenge>(`events/${eventId}/challenges`);

  // Check if event is in uploaders-only mode
  const uploadersOnly = event?.mainConfig?.uploadersOnly ?? false;
  const challengesToPass = uploadersOnly ? [] : challenges;

  return (
    <div className="flex h-screen flex-col ">
      <TopNav showBack isAdmin={isAdmin} />
      <main className="overflow-y-scroll">
        <div className="flex flex-col items-center px-8">
          <h1 className="mb-8 mt-12 text-center text-3xl font-semibold">{t("title")}</h1>
          <p className="mb-8 text-center text-neutral">{t("about")}</p>
          <Loading loading={tLoading || cLoading || eventLoading}>
            <Pictures
              challenges={challengesToPass}
              teams={teams}
              eventId={eventId}
              allowDownload={false}
              allowDelete={false}
            />
          </Loading>
        </div>
      </main>


      {isUploader && <UploaderFooter />}
      {!isAdmin && !isUploader && <Footer />}
    </div>
  );
};
